import { event } from 'utils/analyticsUtils';

import { categories, actions, labels } from './analytics';

const test = action => event(categories, actions, labels, action);

export default test;
